import type { VueQueryPluginOptions } from '@tanstack/vue-query'

export const vueQueryPluginOptions: VueQueryPluginOptions = {
  queryClientConfig: {
    defaultOptions: {
      mutations: {
        networkMode: 'always',
      },
      queries: {
        // value true forces refetching all APIs even when the user is switching between iframes in the same app
        // to keep functionality and performance use custom event https://tanstack.com/query/v4/docs/vue/guides/window-focus-refetching#custom-window-focus-event
        refetchOnWindowFocus: false,
        networkMode: 'always',
        retry: 3,
      },
    },
  },
}
